import { SnackbarProvider as CommonSnackbarProvider } from '@pv/common/providers';

export const PVSnackbarProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return (
    <CommonSnackbarProvider>
      {children}
    </CommonSnackbarProvider>
  );
};
